import { render, staticRenderFns } from "./ContactPromptModal.vue?vue&type=template&id=22488e0d"
import script from "./ContactPromptModal.vue?vue&type=script&lang=ts"
export * from "./ContactPromptModal.vue?vue&type=script&lang=ts"
import style0 from "./ContactPromptModal.vue?vue&type=style&index=0&id=22488e0d&prod&lang=scss&module=true"
import style1 from "./ContactPromptModal.vue?vue&type=style&index=1&id=22488e0d&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports